import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';
import { jsonResponse, sendJson } from 'fetch-utilities';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import { push } from 'react-router-redux';
import _typeof from 'babel-runtime/helpers/typeof';

/**
 * Manage the state of modals and overlays
 */























/**
 * Toggles the given modal, if an other modal is open and the requested modal is not,  it will be closed.
 */

/*
  messages.js
  ------------------------------------------------------------

  Generic message management
*/

var ADD = 'store/messages/ADD';






var addStatus = function addStatus(status, code) {
  return {
    type: ADD,
    status: status,
    code: code
  };
};

var PENDING = 'store/customer/PENDING';
var LOADING = 'store/customer/LOADING';
var LOADED = 'store/customer/LOADED';
var ERROR = 'store/customer/ERROR';
var LOGOUT = 'store/customer/LOGOUT';

var LOGGING_IN = 'store/customer/LOGGING_IN';
var LOGGING_OUT = 'store/customer/LOGGING_OUT';

var REGISTERING = 'store/customer/REGISTERING';

var LOGGED_IN = 'store/customer/LOGGED_IN';
var LOGGED_OUT = 'store/customer/LOGGED_OUT';
var SAVING = 'store/customer/SAVING';
var SAVED = 'store/customer/SAVED';
var REGISTERED = 'store/customer/REGISTERED';
var FORGOT_PASSWORD = 'store/customer/FORGOT_PASSWORD';

var initialState = {
  state: PENDING,
  lastEvent: null,
  data: {},
  loggedIn: false
};

function reducer$$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOGGING_IN:
    case LOGGING_OUT:
    case REGISTERING:
    case SAVING:
    case LOADING:
      return _extends({}, state, {
        lastEvent: action.event || null,
        state: action.type
      });

    case LOADED:
      return _extends({}, state, {
        state: action.error ? ERROR : action.type,
        lastEvent: action.event || null,
        error: action.error,
        data: action.error ? state.data : action.payload || initialState.data,
        errorData: action.error ? action.payload : null,
        loggedIn: !action.error && action.payload ? true : state.loggedIn
      });

    case FORGOT_PASSWORD:
      return _extends({}, state, {
        state: LOADED
      });

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
}

var load = function load() {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING,
      event: LOADING
    });

    dispatch({
      type: LOADED,
      payload: client('/customer').then(jsonResponse).catch(function (err) {
        return !err.httpOk && err.httpStatus === 403 ? null : _Promise.reject(err);
      })
    });
  };
};

var login = function login(data) {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOGGING_IN,
      event: LOADING
    });

    dispatch({
      type: LOADED,
      event: LOGGED_IN,
      payload: client('/customer/login', sendJson({ body: data })).then(jsonResponse)
    });
  };
};

var logout = function logout() {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOGGING_OUT,
      event: LOADING
    });

    dispatch({
      type: LOGOUT,
      event: LOGGED_OUT,
      payload: client('/customer', { method: "DELETE" })
    });
  };
};

var save = function save(customer) {
  return function (dispatch, _getState, client) {
    dispatch({
      type: SAVING,
      event: LOADING
    });

    dispatch({
      type: LOADED,
      event: SAVED,
      payload: client('/customer', sendJson({ method: 'PUT', body: customer })).then(jsonResponse)
    });
  };
};

// see: http://doc.crossroads.se/Crossroads-API/master/#api-Customer-registerCustomer
var register = function register(data) {
  return function (dispatch, _getState, client) {
    data = _extends({}, data, {
      isDefaultBillingAddress: true,
      isDefaultShippingAddress: true,
      countryId: data.country,
      street: [data.street1, data.street2].filter(function (x) {
        return x;
      }),
      attributes: data.attributes ? data.attributes : null
    });

    dispatch({
      type: REGISTERING,
      event: LOADING
    });

    dispatch({
      type: LOADED,
      event: REGISTERED,
      payload: client('/customer', sendJson({ body: data })).then(jsonResponse).then(function (x) {
        return _extends({}, x, { loggedIn: true });
      }).then(function (customer) {
        return client('/customer/addresses', { method: 'POST', body: data }).then(function (_) {
          return customer;
        });
      })
    }).then(function (customer) {
      return dispatch(push('/account'));
    }, function (err) {
      alert(err.message);
      dispatch({ type: LOADED });
      dispatch({ type: REGISTERED });
    });
  };
};

var forgotPassword = function forgotPassword(email) {
  return function (dispatch, _getState, client) {
    dispatch({
      type: SAVING,
      event: LOADING
    });

    dispatch({
      type: FORGOT_PASSWORD,
      event: SAVED,
      payload: client('/customer/forgotpassword', sendJson({ method: 'POST', body: { email: email } })).then(function () {
        dispatch(addStatus('success', 'FORGOT_PASSWORD'));
      })
    });
  };
};

export { PENDING, LOADING, LOADED, ERROR, LOGOUT, LOGGING_IN, LOGGING_OUT, REGISTERING, LOGGED_IN, LOGGED_OUT, SAVING, SAVED, REGISTERED, FORGOT_PASSWORD, load, login, logout, save, register, forgotPassword };
export default reducer$$1;
